module.exports = function getResource(label) {
    const resources = {
        removePhoto: 'Retirer la photo',
        addPhoto: 'Ajouter une photo'
    };
    return resources[label];
};
